import pathOr from 'ramda/src/pathOr'

import moduleDescriptions from 'root/src/shared/descriptions/modules'
import moduleIdFromKey from 'root/src/client/logic/route/util/moduleIdFromKey'

export default (state, { moduleKey, fieldDescPath }) => pathOr(
	false,	[moduleIdFromKey(moduleKey), ...fieldDescPath, 'fieldHalfHeight'],
	moduleDescriptions,
)
